import { AxiosInstance } from 'axios';
import {
  OfferServicesEndpoint,
  CreateOfferRequest,
  CreateBulkOfferRequest,
} from './OfferServices.types';

export class OfferServices implements OfferServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  createOffer(request: CreateOfferRequest) {
    return this.instance.post(`/job/${request.queryParams.jobGuid}/offers`, request.body);
  }

  acceptOffer(jobGuid: string) {
    return this.instance.put(`/job/${jobGuid}/offers/accept`);
  }

  cancelOffer(jobGuid: string) {
    return this.instance.put(`/job/${jobGuid}/offers/cancel`);
  }

  createBulkOffer(request: CreateBulkOfferRequest) {
    return this.instance.put('/bulk/job/offers', request.body);
  }

  cancelBulkOffer(jobGuids: string[]) {
    return this.instance.put('/bulk/job/offers/cancel', { jobGuids });
  }
}
